import type { FaireProductEntity } from "../../entity_types/product";

export const nyc_bev_5: FaireProductEntity = {
  token: "nyc-bev-5",
  type: "product",
  name: "Sparkling Mineral Water",
  brandName: "Pure Source",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/c0ee2a474a3a944d25643290747265441da36bd4982aa3bdff84fdacba4dcf7b.webp",
  priceDollars: 7,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/c0ee2a474a3a944d25643290747265441da36bd4982aa3bdff84fdacba4dcf7b.webp",
  weight: 1,
  dimensions: {
    width: 3,
    height: 8,
    depth: 3,
  },
  description: "Refreshing iced tea from Staten Island",
  categoryTokens: ["cat_food-beverages"],
  tags: ["nyc-local", "premium", "tea"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
